export { default } from "./VerticalCalloutCardButton";
